export const setTitle = (title, showBack, backLink) => (dispatch) => {
    dispatch({ type: 'TITLE_CHANGED', payload: { title, showBack, backLink } });
};
